import { render } from "./InputImageCostume.vue?vue&type=template&id=5b77853f&ts=true"
import script from "./InputImageCostume.vue?vue&type=script&lang=ts"
export * from "./InputImageCostume.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__